import React from 'react';
import { Field } from 'redux-form';
import PostcodeLookup from '../PostcodeLookup/PostcodeLookup';
import { AddressFields } from '../../../../../../common/components/ReduxFormField';
import InputError from '../../../InputError/InputError';
import { Col, Row } from 'react-bootstrap';

const Address = ({ meta, input, labelSize }) => {
  const updateAddress = (address) => {
    input.onChange({
      ...address,
    });
  };

  const clearAddress = () => {
    input.onChange({
      line1: '',
      line2: '',
      line3: '',
      town: '',
      county: '',
      postcode: '',
      country: '',
    });
  };

  return (
    <>
      <Field
        labelSize={labelSize}
        fieldSize={6}
        name={'address.postcode'}
        label="Postcode"
        placeholder={'Postcode'}
        component={PostcodeLookup}
        updateAddress={updateAddress}
        clearAddress={clearAddress}
      />
      <AddressFields
        baseName={'address'}
        label="Address"
        labelSize={labelSize}
        smFieldSize={6}
      />
      <Row>
        <Col smOffset={labelSize}>
          <InputError meta={meta} />
        </Col>
      </Row>
    </>
  );
};

export default Address;
